import React, { useState } from 'react';

import { Tooltip } from './tooltip';

interface CopyItemProps extends React.PropsWithChildren {
	textToCopy: string;
	className?: string;
}

export function CopyItem({ textToCopy, children }: CopyItemProps) {
	const [copied, setCopied] = useState(false);
	const [isOpen, setIsOpen] = useState(false);

	const handleCopyClick = async (e: React.MouseEvent) => {
		e.stopPropagation();

		try {
			await navigator.clipboard.writeText(textToCopy);
			setCopied(true);
			setIsOpen(true); // Keep tooltip open
			setTimeout(() => {
				setCopied(false);
				setIsOpen(false); // Close tooltip after showing "Copied"
			}, 1200);
		} catch (error) {
			console.error('Failed to copy email:', error);
		}
	};

	return (
		<Tooltip
			open={copied ? isOpen : undefined}
			onOpenChange={copied ? undefined : setIsOpen}
			text={copied ? 'Copied!' : 'Click to copy'}
			triggerProps={{
				onClick: handleCopyClick,
			}}
			side="bottom"
			align="start"
		>
			{children}
		</Tooltip>
	);
}
